import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset } from '@fortawesome/free-solid-svg-icons';

const SupportEngineLoader = () => {
  return (
    <div className="se-loader-screen">
      <div className="text-center">
        <div className="se-loader-logo mx-auto">
          <FontAwesomeIcon icon={faHeadset} size="lg" />
        </div>
        <h5 className="fw-bold text-900 mb-1" style={{ fontSize: '1.25rem' }}>
          Cargando Support Engine
        </h5>
        <div className="se-loader-bar mx-auto">
          <div className="se-loader-fill"></div>
        </div>
      </div>
    </div>
  );
};

export default SupportEngineLoader;
